// extracted by mini-css-extract-plugin
export default {"container":"SubCategoriesList_container__n7Z3t","containerInModal":"SubCategoriesList_containerInModal__WvKl9","card":"SubCategoriesList_card__9N7gE"};